import { useQuery } from '@tanstack/react-query';
import { fetchAllVehicles } from '../services';

interface VehicleParams {
  status?: string,
  isNewVehicle?: boolean,
  enabled?: boolean,
}

const getVehicles = async ({ status, isNewVehicle }: VehicleParams) => {
  const {
    data: {
      results
    }
  } = await fetchAllVehicles({ status, isNewVehicle });
  return results;
};

const useQueryVehicles = (params: VehicleParams) => {
  const { enabled, status, isNewVehicle } = params;
  const { data, isLoading, isError } = useQuery({
    queryKey: ['getVehicles', status, isNewVehicle],
    queryFn: () => getVehicles({ status, isNewVehicle }),
    enabled,
  });

  return {
    data,
    isLoading,
    isError,
  };
};

export default useQueryVehicles;
